module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./~/amazon-cognito-identity-js/~/aws-sdk/apis/cognito-identity-2014-06-30.paginators.json
// module id = 486
// module chunks = 4